module.exports = __webpack_public_path__ + "img/62_3.78d266db.png";